var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-tag",attrs:{"name":_vm.name,"title":_vm.title}},[_c('div',{staticClass:"scroll-tag-dot",class:{
                'is-active': _vm.active
            }}),_c('div',{staticClass:"scroll-tag-value single-line-clip"},[_vm._v(_vm._s(_vm.title))]),_c('common-icon',{staticClass:"scroll-tag-close",attrs:{"type":"ios-close"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.onClose.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }